import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { Card, Button } from '@mui/material';
import { useParams, useHistory } from 'react-router';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import * as actions from '../../redux/actions';
import { BackButton } from '../../components/Button';
import HolidayForm from '../../components/Forms/HolidayForm';
import { Loading } from '../../components/Loading';
import { Error } from '../../components/Error';
import { showAlert } from '../../utils/functions/globalDialog';

export default function EditHoliday({ title, subtitle }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const holiday = useSelector((state) => state.holiday);
  const {
    formState: { errors },
    handleSubmit,
    control,
    reset,
  } = useForm();
  const [startDate, setStartDate] = useState();

  useEffect(() => {
    dispatch(actions.holidayGet(id));
    return () => {};
  }, [dispatch, id]);

  useEffect(() => {
    if (holiday?._id === id) {
      reset({ name: holiday.name || '' });
      setStartDate(holiday.date ? dayjs(holiday.date) : undefined);
    }
  }, [holiday, id, reset]);

  const onSubmit = async (data) => {
    if (!startDate) return;
    try {
      await dispatch(actions.holidayPut(id, { ...data, date: dayjs(startDate).toDate() }));
      showAlert('สำเร็จ');
      history.push('/management/holiday');
    } catch (error) {
      console.error(error);
    }
  };

  if (holiday.isLoading) {
    return <Loading />;
  }
  if (!holiday.isLoading && holiday.isCompleted) {
    return (
      <div>
        <div className="flex flex-row justify-start pb-4">
          <div>
            <BackButton />
          </div>
        </div>
        <div>
          <Card className="p-4">
            <form onSubmit={handleSubmit(onSubmit)}>
              <HolidayForm
                control={control}
                Controller={Controller}
                errors={errors}
                holiday={holiday}
                startDate={startDate}
                setStartDate={setStartDate}
              />
              <div className="flex flex-row justify-end gap-1 py-4">
                <Button variant="contained" type="submit">
                  บันทึก
                </Button>
              </div>
            </form>
          </Card>
        </div>
      </div>
    );
  }
  return <Error message={holiday?.message} />;
}

EditHoliday.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

EditHoliday.defaultProps = {
  title: '',
  subtitle: '',
};
